import IconLoader from '@shared/icons/IconLoader';
import { Loader } from '@shared/uikit/loader';

type LoadingProps = {
  customClass?: string;
  label?: string;
};

const Loading: React.FC<LoadingProps> = ({ customClass = '', label }) => {
  return (
    <div
      className={`fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-[#141316] flex flex-col items-center justify-center ${customClass}`}
    >
      <div className="h-[100px] w-[100px]">
        <Loader loading={true} />
      </div>
      <h2 className="loading text-[#D7F525]" style={{ color: '#D7F525' }}>
        {label ? label : 'Загрузка...'}
      </h2>
    </div>
  );
};

export default Loading;
